import { Download, Search, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUSES, PRIORITIES, QRC_TYPES, LEVELS } from "@/lib/constants";

const ALL = "__all__";

function FilterSelect({ value, onChange, options, placeholder, testId }) {
  return (
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
      <SelectTrigger className="h-11 rounded-xl border-2 border-black bg-white text-sm font-semibold" data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="border-2 border-black">
        <SelectItem value={ALL}>{placeholder}: All</SelectItem>
        {options.map((o) => (
          <SelectItem key={o} value={o}>{o}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export const EMPTY_FILTERS = { product: "", status: "", priority: "", qrc_type: "", escalation_level: "", search: "" };

export function Filters({ filters, setFilters, products, onExport, exporting }) {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="space-y-3" data-testid="filters-bar">
      <div className="flex flex-col gap-3 sm:flex-row">
        <label className="relative flex-1">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
          <input
            className="field-input !py-2.5 !pl-10"
            placeholder="Search name, phone, email or ticket id…"
            value={filters.search}
            onChange={(e) => set("search")(e.target.value)}
            data-testid="search-input"
          />
        </label>
        <div className="flex gap-2">
          {active && (
            <button className="btn-ghost" onClick={() => setFilters(EMPTY_FILTERS)} data-testid="clear-filters-button">
              <X className="h-4 w-4" /> Clear
            </button>
          )}
          <button className="btn-dark !py-2.5" onClick={onExport} disabled={exporting} data-testid="download-csv-button">
            <Download className="h-4 w-4" /> {exporting ? "Preparing…" : "Download CSV"}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-5">
        <FilterSelect value={filters.product} onChange={set("product")} options={products} placeholder="Product" testId="filter-product-select" />
        <FilterSelect value={filters.status} onChange={set("status")} options={STATUSES} placeholder="Status" testId="filter-status-select" />
        <FilterSelect value={filters.priority} onChange={set("priority")} options={PRIORITIES} placeholder="Priority" testId="filter-priority-select" />
        <FilterSelect value={filters.qrc_type} onChange={set("qrc_type")} options={QRC_TYPES} placeholder="QRC type" testId="filter-qrc-select" />
        <FilterSelect value={filters.escalation_level} onChange={set("escalation_level")} options={LEVELS} placeholder="Escalation" testId="filter-escalation-select" />
      </div>
    </div>
  );
}
